module.exports = __webpack_public_path__ + "static/Kalapala-2221b2252b1eee38a6132fcaf5d50cab.png";